import { render, staticRenderFns } from "./head-page-provider.vue?vue&type=template&id=71f75071"
import script from "./head-page-provider.vue?vue&type=script&lang=js"
export * from "./head-page-provider.vue?vue&type=script&lang=js"
import style0 from "./head-page-provider.vue?vue&type=style&index=0&id=71f75071&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports